import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";

async function updatePropertyData(titolo, formData) {
  try {
    // Trova il documento con l'ID uguale al titolo
    const propertyDocRef = doc(db, "immobili", titolo);
    const propertyDoc = await getDoc(propertyDocRef);

    if (propertyDoc.exists()) {
      console.log("Immobile trovato. Aggiornamento in corso...");
      const existingData = propertyDoc.data();
      console.log("Dati esistenti (prima dell'aggiornamento):", existingData);

      // Crea un oggetto per i cambiamenti
      const updates = {
        indirizzo: formData.indirizzo || existingData.indirizzo,
        prezzo: formData.prezzo || existingData.prezzo,
        grandezza: formData.grandezza || existingData.grandezza,
        camere: formData.camere || existingData.camere,
        bagni: formData.bagni || existingData.bagni,
        piano: formData.piano || existingData.piano,
        dettagli: formData.dettagli || existingData.dettagli,
        contratto: formData.contratto || existingData.contratto,
        descrizione: formData.descrizione || existingData.descrizione,
        pianiEdificio: formData.pianiEdificio || existingData.pianiEdificio,
        ascensore: formData.ascensore || existingData.ascensore,
        superficie: formData.superficie || existingData.superficie,
        locali: formData.locali || existingData.locali,
        cucina: formData.cucina || existingData.cucina,
        arredato: formData.arredato || existingData.arredato,
        balcone: formData.balcone || existingData.balcone,
        terrazzo: formData.terrazzo || existingData.terrazzo,
        riscaldamento: formData.riscaldamento || existingData.riscaldamento,
        climatizzazione:
          formData.climatizzazione || existingData.climatizzazione,
        speseCondominio:
          formData.speseCondominio || existingData.speseCondominio,
        classeEnergetica:
          formData.classeEnergetica || existingData.classeEnergetica,
        condizioni: formData.condizioni || existingData.condizioni,
      };

      // Aggiorna il documento
      await updateDoc(propertyDocRef, updates);
      console.log("Immobile aggiornato con successo!");

      // Verifica l'aggiornamento
      const updatedPropertyDoc = await getDoc(propertyDocRef);
      console.log(
        "Dati aggiornati (dopo l'aggiornamento):",
        updatedPropertyDoc.data()
      );
    } else {
      console.error("Immobile non trovato. Impossibile aggiornare.");
    }
  } catch (error) {
    console.error("Errore durante l'aggiornamento dell'immobile:", error);
  }
}

export default updatePropertyData;
